import mainLogo from '../../images/Discautol/GrupoDIscautol_logo_black_main.png';
import squareLogo from '../../images/Discautol/GrupoDIscautol_logo_black_small.png';
import bannerLogoWhite from '../../images/Discautol/GrupoDIscautol_logo_white_main.png';
import banner01 from '../../images/Discautol/vw_woman_01_bg.jpg';
import banner02 from '../../images/Discautol/vw_woman_01_mobile_bg.jpg';
import banner03 from '../../images/Discautol/vw_brand_bg.jpg';
import banner04 from '../../images/Discautol/vw_bg_3.1.jpg';
import car123 from '../../images/Discautol/123_virtus.jpg';
import box123 from '../../images/Discautol/123_vw.jpg';
import saleBanner01 from '../../images/Discautol/sale/consumerWeek_bg_01.jpg';
import saleImg01 from '../../images/Discautol/sale/consumerWeek_img_01.png';
import saleImg02 from '../../images/Discautol/sale/semanaConsumidor_img_02_wide.png';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Discautol',
    defaultStoreLink: 'loja.discautol.com.br',
    defaultContactEmail: 'ecommerce@discautol.com.br',
    whatsappNumber: '67 99295 9048',
    CNPJname: 'Luson Veiculos LTDA',
    CNPJ: '03.244.290/0001-07',
    CNPJaddress: 'Av. Mato Grosso, 5046 - Carandá Bosque, Campo Grande, MS - 79.030-001',
    launchDate: '07/09/2024',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: 'SEMANA05',
        //     discountPrice: 0,
        //     discountPercent: 0.05,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATISDISCAUTOL',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
        {
            coupon: 'PRIMEIRACOMPRA05',
            discountPrice: 0,
            discountPercent: 0.05,
            freeShipping: false,
            oneTime: true,
        },
    ],

    brands: [
        'citroen',
        'peugeot',
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "DISCAUTOL VW CARANDA",
        "DISCAUTOL PSA - AHO FRANCE",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    pixDiscount: 0.05,

    payment: {
        maxParcels: 10,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
            8000: 10,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits Revisão',
            img: 'tabKits',
            products: [
                'GPKITREVISAOEA111COMPLETO',
                'GPKITREVISAOEA111COMPLETOB',
                'GPKITREV250TSICOMPLETA',
                'GPKITREVISAOCOMPLETOEA11116',
            ]
        },
        {
            name: 'Correias',
            img: 'tabCorreias',
            products: [
                'GPKITCORREIATENSORPINOEA211',
                'GPKITTODASCORREIASEA111',
                'GPKITTODASCORREIASEA211V2',
                'GPKITTODASCORREIASEA211V3',
                'GPKITTODASCORREIASEA211',
                'GPKITTODASCORREIASEA211V11',
            ]
        },
        {
            name: 'Motores',
            img: 'tabMotores',
            products: [
                '02T911021E',
                '04C100031F',
                '04C100034',
                '04C100034D',
                '04E100033M',
                '032100033H',
            ]
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Pastilhas',
            img: 'tabFreios',
            products: [
                'JZZ698151AE',
                'JZZ698151AK',
                'JZW698451A',
                '5Z0698151B',
                '2Q0698151R',
            ]
        },
        {
            name: 'Bicos Injetores',
            img: 'tabBicos',
            products: [
                'GPKIT4X03L130277Q',
                'GPKITBOMBABICOSAMAROK4CC',
                'GPKIT3BICOS04E906036AR',
                'GPKIT4BICOS032906031R',
            ]
        },
        {
            name: 'Pneus',
            img: 'tabPneus',
            products: [
                'V04011009MPRGY',
                '2QB601307ACRGY',
                '2QB601307ADRGY',
            ]
        },
        // {
        //     name: 'Filtros',
        //     img: 'tabFiltros',
        //     products: SliderProducts.Filtros
        // },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        // {
            //     name: 'Roupas',
            //     img: 'tabRoupas',
            //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,
    bannerImg01: bannerLogoWhite,

    banner01: banner04,
    banner02: banner01,
    banner03: banner03,
    banner04: '',
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: saleBanner01,
    bannerSpecialMobile: saleBanner01,
    imgSepcial: saleImg01,
    imgSepcialMobile: saleImg01,

    saleImg02: saleImg02,

    bannerHighlight: 'Compre peças originais para o seu veículo <span style="font-weight: bold;">Volkswagen, Peugeot ou Citroen</span> direto das concessionárias <span style="font-weight: bold;">Discautol</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'O Grupo Discautol tem o objetivo de entregar a melhor experiência de compra de autopeças genuínas Volkswagen, direto das concessionárias.',
            'Somos uma empresa sul-mato-grossense com muito amor pela história que está sendo escrita desde 1967. Com fundação sólida e cultura forte, sonhamos grande buscando sempre proporcionar o melhor atendimento possível para nossos clientes e amigos.'
        ],
        link: 'https://www.discautol.com.br/empresa/quemsomos',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/discautol/',
        Facebook: 'https://www.facebook.com/discautol/',
        LinkedIn: 'https://www.linkedin.com/company/grupodiscautol/',
        Youtube: 'https://www.youtube.com/channel/UCsxICImjxZMqRLpcOnaCxKw',
        Twitter: '',
    },

    footerContent: [],
}